import React, { useEffect, useState, useContext } from "react";
import { Modal } from "react-bootstrap";
import { BiTrash, BiPencil } from "react-icons/bi";
import "./taxonomy.css";
import { v4 as uuidv4 } from "uuid"; // Importing UUID generator
import { trackPromise } from "react-promise-tracker";
import LoadingOverlay from "../../reusable-components/LoadingOverlay/LoadingOverlay";
import taxonomyService from "../../api/taxonomyService";
import { NavLink, useNavigate } from "react-router-dom";
import { interceptorsSetup } from "../../api/intreceptor";
import { Box, Button, Flex, FormLabel, useToast } from "@chakra-ui/react";
import { MultiSelect } from "react-multi-select-component";
import MultiSelectStyle from "../../assets/styles/CreateDepartment.module.css";
import { FiPlus } from "react-icons/fi";
import departmentService from "../../api/departmentService";
import PromptEditor from "./components/promptEditor";
import 'react-quill/dist/quill.snow.css';
import { RxCross1 } from "react-icons/rx";
import useFetchConfigSetting from "../../hooks/useConfigSetting";
import { FaFileExcel } from "react-icons/fa";
import { CentralizeStore } from "../../contexts/CentralizeStoreProvider";
import { useConfirm } from "../../reusable-components/confirm-dialog/ConfirmDialogProvider";


const stripHtmlTags = (html) => {
	return html
		.replace(/<p[^>]*>/g, ' ')
		.replace(/<\/p>/g, ' ')
		.replace(/<div[^>]*>/g, '')
		.replace(/<\/div>/g, '')
		.replace(/<br\s*\/?>/g, ' ')
		.replace(/\s{2,}/g, ' ')
		.replace(/<ol[^>]*>/g, ' ')
		.replace(/<\/ol>/g, ' ')
		.replace(/<li[^>]*>/g, ' ')
		.replace(/<\/li>/g, ' ')
		.replace(/<ul[^>]*>/g, ' ')
		.replace(/<\/ul>/g, ' ')
		.replace(/<ul[^>]*>/g, ' ')
		.replace(/<\/ul>/g, ' ')
		.replace(/<strong[^>]*>/g, ' ')
		.replace(/<\/strong>/g, ' ')
		.replace(/<em[^>]*>/g, ' ')
		.replace(/<\/em>/g, ' ')
		.replace(/<u[^>]*>/g, ' ')
		.replace(/<\/u>/g, ' ')
		.trim();
};

const Taxonomy = React.memo(() => {
	const [loading, setLoading] = useState(true);
	const [loaderMessage, setLoaderMessage] = useState("Fetching Domains...");
	const [domainsData, setDomainsData] = useState({
		domains: [],
		categories: [],
	});
	const [domainOpen, setDomainOpen] = useState(true);
	const [categoryOpen, setCategoryOpen] = useState(true);
	const [defaultselectedCategories, defaultsetSelectedCategories] = useState(
		[]
	);
	const [isExcel, setIsExcel] = useState(false);
	const [show, setShow] = useState(false);
	const [categoryName, setCategoryName] = useState("");
	const [showCategoryModal, setShowCategoryModal] = useState(false);
	const [selectedDomain, setSelectedDomain] = useState(null);
	const [selectedDomainData, setSelectedDomainData] = useState(null);
	const [mode, setMode] = useState("add");
	const [selectedCategory, setSelectedCategory] = useState(null);
	const [attributes, setAttributes] = useState([]);
	const [domainNameModal, setDomainNameModal] = useState("");
	const [selectedCategoryData, setSelectedCategoryData] = useState(null);
	const [editCategoryName, setEditCategoryName] = useState("");
	const [excelData, setExcelData] = useState({})
	const [excelSelcetedData, setExcelSelectedData] = useState({})
	const [excelrows, setExcelRows] = useState([{ input: "", select: "" }]);
	const [domainDesc, setDomainDesc] = useState(null);
	const [domainPrompt, setDomainPrompt] = useState(null);
	const [activeDepartments, setActiveDepartments] = useState([]);
	const [selectedIds, setSelectedIds] = useState([]);
	const { fetchConfigSetting } = useFetchConfigSetting()
	const { configSettings } = useContext(CentralizeStore);
	const toast = useToast();
	const confirm = useConfirm();
	const navigate = useNavigate();
	const comp_id = localStorage.getItem("comp_id")
	const role = localStorage.getItem("role")
	const [selectedprompt, setSelectedPrompt] = useState([]);
	const [prompt, setPrompts] = useState([]);

	useEffect(() => {
		if (configSettings?.descriptionPrompt?.Prompt_Tag?.length > 0) {
		  const promptTagObject = configSettings.descriptionPrompt.Prompt_Tag[0];
		  const data = Object.keys(promptTagObject).map(key => ({
			label: key,
			value: key,
		  }));
		  setPrompts(data);
		}
	  }, [configSettings]);


	useEffect(() => {
		interceptorsSetup(navigate);
	}, [navigate]);

	useEffect(() => {
		fetchConfigSetting()
		getAllDomains();
	}, []);

	const getDepartments = async () => {
		try {
			const res = await departmentService.getActiveDepartment(comp_id);
			if (res.status === 200) {
				setActiveDepartments(res.data.departments);
			}
		} catch (err) {
			console.log("err:", err);
		}
	};
	const getAllDomains = () => {
		setLoading(true);
		trackPromise(
			taxonomyService
				.getTaxonomy(comp_id)
				.then((response) => {
					if (response.status === 200) {
						const data = response.data.taxnonmies;
						const processedData = processData(data);
						setDomainsData(processedData);
						setLoading(false);
						getDepartments();
					}
				})
				.catch((err) => {
					setLoading(false);
					// Handle error
				})
		);
	};
	const processData = (data) => {
		if (!data || data.length === 0) {
			return { domains: [], categories: [] };
		}
		const domains = data.map((item) => ({
			domain_id: item.id,
			id: item.id,
			domain: item.domain_name,
			// category_count: item.category_count,
			// attributes_count: item.attributes_count,
			department_id: item.department_id,
			domain_description: item.domain_description,
			domain_prompt: item.domain_prompt,
			domain_prompt_custom: item.domain_prompt_custom,
			domain_name: item.domain_name,
			categories: item.categories.map((category) => ({
				cat_id: category.cat_id,
				cat_name: category.cat_name,
				attributes: category.attributes, // Assuming attributes are directly nested within the category object
			})),
			download_column: item.download_column,
			description_prompts: item.description_prompts || [],
		}));
		const categories = domains.reduce((acc, domain) => {
			domain.categories.forEach((category) => {
				acc.push(category);
			});
			return acc;
		}, []);
		return {
			domains: domains,
			categories: categories,
		};
	};

	const handleDomainClick = (domain) => {
		setSelectedDomain(domain);
		setDomainNameModal(domain.domain);
		setDomainDesc(domain.domain_description)
		// setDomainPrompt(domain.domain_prompt)
		setDomainPrompt(domain.domain_prompt_custom)
		defaultsetSelectedCategories(domain.categories || []);
		const selectedPromptObjects = prompt.filter(option =>
			domain.description_prompts?.includes(option.value)
		);
		setSelectedPrompt(selectedPromptObjects || []);
		const newSelectedCategory = domain.categories.find(
			(cat) => cat.cat_id === selectedCategory?.cat_id
		);

		if (newSelectedCategory) {
			setSelectedCategory(newSelectedCategory);

			if (Array.isArray(newSelectedCategory.attributes)) {
				setAttributes(newSelectedCategory.attributes);
			} else {
				setAttributes([]);
			}
		} else {
			setSelectedCategory(null);
			setAttributes([]);
		}
	};

	const handleCategoryClick = (category) => {
		setSelectedCategory(category);
		if (category.attributes) {
			const attributeArray = Object.entries(category.attributes).map(
				([attribute, value]) => ({
					attribute: attribute,
					value: value.join(", "),
				})
			);
			setAttributes(attributeArray);
		} else {
			setAttributes([]);
		}
	};

	useEffect(() => {
		if (domainsData && domainsData.domains && domainsData.domains.length > 0) {
			// Check if the selected domain exists in the fetched data
			const selectedDomainExists = domainsData.domains.some(
				(domain) => domain.domain_id === selectedDomain?.domain_id
			);

			// If the selected domain exists in the fetched data, update selected domain and category
			if (selectedDomainExists) {
				const selectedDomainData = domainsData.domains.find(
					(domain) => domain.domain_id === selectedDomain.domain_id
				);
				setSelectedDomain(selectedDomainData);
				// Refresh all categories when domains data changes
				defaultsetSelectedCategories(selectedDomainData.categories || []);

				// Set attributes for the first category of the selected domain if a category is selected
				if (selectedCategory) {
					const firstCategory = selectedDomainData.categories.find(
						(category) => category.cat_id === selectedCategory.cat_id
					);
					if (firstCategory && firstCategory.attributes) {
						const attributeArray = Object.entries(firstCategory.attributes).map(
							([attribute, value]) => ({
								attribute: attribute,
								value: value.join(", "),
							})
						);
						setAttributes(attributeArray);
					} else {
						setAttributes([]);
					}
				} else {
					// If no category is selected, do not set attributes
					setAttributes([]);
				}
			} else {
				// If the selected domain does not exist in the fetched data, select the first domain and its first category
				const firstDomain = domainsData.domains[0];
				defaultsetSelectedCategories(firstDomain.categories || []);
				setSelectedDomain(firstDomain);
				// setSelectedCategory(firstDomain.categories[0]);
				const attributeArray = (
					firstDomain.categories[0]?.attributes
						? Object.entries(firstDomain.categories[0].attributes)
						: []
				).map(([key, value]) => ({ attribute: key, value: value.join(", ") }));
				setAttributes(attributeArray);
			}
		}
	}, [
		domainsData,
		selectedDomain,
		selectedCategory,
		defaultselectedCategories,
	]);

	useEffect(() => {
		if (excelSelcetedData && Object.keys(excelSelcetedData).length > 0) {
			const formattedRows = Object.entries(excelSelcetedData).map(([key, value]) => ({
				input: key,
				select: value ? value : ""
			}));
			// If no valid rows, set an empty object
			setExcelRows(formattedRows);
		} else {
			setExcelRows([{ input: "", select: "" }]); // If no data, set to [{}]
		}
	}, [excelSelcetedData]);




	const handleClose = () => {
		setShow(false);
	};

	const handleShow = (domain) => {
		if (domain) {
			setMode("edit");
			setSelectedDomainData(domain);
			setDomainNameModal(domain.domain);
			setDomainDesc(domain.domain_description)
			// setDomainPrompt(domain.domain_prompt)
			setDomainPrompt(domain.domain_prompt_custom)
			const preSelectedOptions = departmentOptions?.filter(option =>
				domain?.department_id?.includes(option.value)
			);
			setSelectedIds(preSelectedOptions || []);
			const preSelectedPromptOptions = prompt?.filter(option =>
				domain?.description_prompts?.includes(option.value)
			);
			setSelectedPrompt(preSelectedPromptOptions || []);
		} else {
			setMode("add");
			setSelectedDomainData(null);
			setDomainNameModal("");
			setDomainDesc("")
			setDomainPrompt("")
			setSelectedIds([])
			setSelectedPrompt([]);
		}
		setShow(true);
	};

	const handleSaveDomain = () => {
		if (mode === "add") {
			if (!(domainNameModal.length > 0 && domainDesc.length > 0 && department_id.length > 0)) {
				return (
					toast({
						title: "Required fields are mandatory.",
						position: "top",
						status: "warning",
						duration: 2000,
						variant: "left-accent",
						isClosable: true,
					})
				)
			}

			const cleanDomainPrompt = stripHtmlTags(domainPrompt);
			const newDomain = {
				domain_id: uuidv4(),
				domain_name: domainNameModal,
				domain_prompt: cleanDomainPrompt,
				domain_description: domainDesc,
				department_id: department_id,
				domain_prompt_custom: domainPrompt,
				comp_id: comp_id,
				description_prompts: selectedprompt.map(item => item.value)
			}

			setLoading(true)
			taxonomyService.createDomain(newDomain)
				.then((response) => {
					setDomainsData((prevState) => ({
						...prevState,
						domains: [...prevState.domains, newDomain],
					}));
					setSelectedDomain(newDomain);
					toast({
						title: `${response.data.message}`,
						position: "top",
						status: "success",
						duration: 2000,
						variant: "left-accent",
						isClosable: true,
					})
					getAllDomains(); // Set the newly added domain as selected
					handleClose();
				})
				.catch((err) => {
					toast({
						title: `Something went wrong.`,
						position: "top",
						status: "error",
						duration: 2000,
						variant: "left-accent",
						isClosable: true,
					})
					console.log("create domain err:", err);
				})
				.finally(() => {
					setLoading(false)
				})
		} else if (mode === "edit") {
			if (
				domainsData.domains.some(
					(d) =>
						d.domain.toLowerCase() === domainNameModal.toLowerCase() &&
						d.domain_id !== selectedDomainData?.domain_id
				)
			) {
				return (
					toast({
						title: "Domain name already exists!",
						position: "top",
						status: "warning",
						duration: 2000,
						variant: "left-accent",
						isClosable: true,
					})
				)
			}
			const cleanDomainPrompt = stripHtmlTags(domainPrompt);
			const updateDomain = {
				...selectedDomainData,
				domain_name: domainNameModal,
				domain_prompt: cleanDomainPrompt,
				domain_description: domainDesc,
				department_id: department_id,
				id: selectedDomainData.id,
				domain_prompt_custom: domainPrompt,
				description_prompts: selectedprompt.map(item => item.value)
			}
			setLoading(true);
			taxonomyService.updateDomain(updateDomain)
				.then((response) => {
					if (response.status === 200) {

						setDomainsData((prevState) => ({
							...prevState,
							domains: prevState.domains.map((domain) =>
								domain.domain_id === updateDomain.domain_id
									? updateDomain
									: domain
							),
						}));
						toast({
							title: `${response.data.new.message}`,
							position: "top",
							status: "success",
							duration: 2000,
							variant: "left-accent",
							isClosable: true,
						})
						setSelectedDomain(updateDomain); // Keep the updated domain as selected
					}
				})
				.catch((err) => {
					console.log("update domain err:", err);
				})
				.finally(() => {
					handleClose();
					setLoading(false)
				})
		}
	};

	const handleCloseCategoryModal = () => {
		setShowCategoryModal(false);
		setCategoryName("");
	};

	const handleShowCategoryModal = (mode, category) => {
		setMode(mode); // Set the mode (add or edit)
		setSelectedCategoryData(category); // Set the selected category data
		setShowCategoryModal(true); // Open the category modal
	};

	const handleEditCategory = (category) => {
		setSelectedCategoryData(category);
		setMode("edit");
		setShowCategoryModal(true);
		setEditCategoryName(category.cat_name); // Set the category name being edited
	};

	const handleAddCategory = () => {
		if (!selectedDomain) {
			return (
				toast({
					title: `No domain selected`,
					position: "top",
					status: "warning",
					duration: 2000,
					variant: "left-accent",
					isClosable: true,
				})
			)
		}

		if (!editCategoryName) {
			return (
				toast({
					title: `Please enter a category name.`,
					position: "top",
					status: "warning",
					duration: 2000,
					variant: "left-accent",
					isClosable: true,
				})
			)
		}

		if (
			defaultselectedCategories.some(
				(c) => c.cat_name.toLowerCase() === editCategoryName.toLowerCase()
			)
		) {
			return (
				toast({
					title: `Category name already exists in this domain !`,
					position: "top",
					status: "warning",
					duration: 2000,
					variant: "left-accent",
					isClosable: true,
				})
			)
		}

		const newCategory = {
			domain_name: selectedDomain.domain,
			domain_id: selectedDomain.domain_id,
			id: selectedDomain.domain_id,
			categories: [
				{
					cat_id: uuidv4(),
					cat_name: editCategoryName,
					attributes: {},
				},
			],
		};

		if (mode === "add") {
			setEditCategoryName("");
			setLoading(true);
			trackPromise(
				taxonomyService
					.createCategory({ id: newCategory.id, cat_name: editCategoryName, attributes: {} })
					.then((response) => {
						// alert(response.data.message);
						if (response.status === 200) {
							toast({
								title: `${response.data.message}`,
								position: "top",
								status: "success",
								duration: 2000,
								variant: "left-accent",
								isClosable: true,
							})
							getAllDomains();
							// setEditCategoryName('');
							handleCloseCategoryModal();
							setShowCategoryModal(false);
						}
					})
					.catch((err) => {
						console.log("create category err: ", err)
					})
					.finally(() => {
						setLoading(false)
					})
			);
		} else if (mode === "edit") {
			const updateCategory = {
				domain_name: selectedDomain.domain,
				domain_id: selectedDomain.domain_id,
				categories: [
					{
						cat_id: selectedCategory.cat_id,
						cat_name: editCategoryName,
						attributes: {},
					},
				],
			};
			setLoading(true)
			trackPromise(
				taxonomyService.updateCategory({ id: selectedDomain.domain_id, cat_id: selectedCategory.cat_id, cat_name: editCategoryName })
					.then((response) => {
						// alert(response.data.message);
						if (response.status === 200) {
							toast({
								title: `${response.data.new.message}`,
								position: "top",
								status: "success",
								duration: 2000,
								variant: "left-accent",
								isClosable: true,
							})
							// getAllDomains();
							const data = response.data.taxnonmies;
							const processedData = processData(data);
							setDomainsData(processedData);
							setEditCategoryName("");
						}
						handleCloseCategoryModal();
						setShowCategoryModal(false);
					})
					.catch((err) => {
						console.log("update category err: ", err)
					})
					.finally(() => {
						setLoading(false)
					})
			);
		}
	};

	const handleInputChange = (index, key, value) => {
		const updatedAttributes = [...attributes];
		const updatedAttribute = { ...updatedAttributes[index] };
		updatedAttribute[key] = value;
		updatedAttributes[index] = updatedAttribute;
		setAttributes(updatedAttributes);
	};

	const handleAddAttribute = () => {
		setAttributes((prevAttributes) => [
			...prevAttributes,
			{ name: "", value: "" },
		]);
	};
	const handleRemoveAttribute = async (index) => {
		const attribute = attributes[index];
		// Rows use either `attribute` or `name` for the label (see handleAddAttribute vs the table input).
		const label = String(attribute?.attribute ?? attribute?.name ?? "").trim();
		const hasContent = label !== "" || String(attribute?.value ?? "").trim() !== "";
		// A row that was just added and is still blank needs no "are you sure".
		if (hasContent) {
			const confirmed = await confirm({
				title: "Remove this attribute?",
				message: `${label ? `"${label}"` : "This attribute"} will be removed from the list.\nThe change is only saved when you click Save.`,
				confirmLabel: "Remove",
			});
			if (!confirmed) return;
		}
		setAttributes((prevAttributes) =>
			prevAttributes.filter((_, i) => i !== index)
		);
	};

	const handleSaveAttributes = () => {
		if (!selectedCategory || !selectedCategory.cat_id) {
			// alert("Please select a category!");
			return (
				toast({
					title: `Please select a category!`,
					position: "top",
					status: "warning",
					duration: 2000,
					variant: "left-accent",
					isClosable: true,
				})
			)
		}

		const attributeNames = attributes.map((attr) => attr.attribute);
		const lowerCaseAttributeNames = attributeNames.map((attr) =>
			(attr?.trim() ?? "").toLowerCase()
		);

		const upperCaseAttributeNames = attributeNames.map((attr) =>
			(attr?.trim() ?? "").toUpperCase()
		);

		const uniqueAttributeNames = new Set([
			...lowerCaseAttributeNames,
			...upperCaseAttributeNames,
		]);

		const hasDuplicates =
			uniqueAttributeNames.size !==
			lowerCaseAttributeNames.length + upperCaseAttributeNames.length;

		if (
			attributes.some(
				(attr) =>
					!attr.attribute ||
					!attr.value ||
					typeof attr.attribute.trim !== "function" ||
					typeof attr.value.trim !== "function" ||
					!attr.attribute.trim() ||
					!attr.value.trim()
			)
		) {
			// alert("Attribute names and values cannot be empty!");
			return (
				toast({
					title: `Attribute names and values cannot be empty !`,
					position: "top",
					status: "warning",
					duration: 2000,
					variant: "left-accent",
					isClosable: true,
				})
			)
		}

		if (hasDuplicates) {
			// alert("Duplicate attribute names are not allowed!");
			return (
				toast({
					title: `Duplicate attribute names are not allowed !`,
					position: "top",
					status: "warning",
					duration: 2000,
					variant: "left-accent",
					isClosable: true,
				})
			)
		}

		const formattedAttributes = {};
		attributes.forEach((attribute) => {
			const trimmedAttr = attribute.attribute.trim();
			const trimmedValue = attribute.value.trim();
			if (formattedAttributes[trimmedAttr]) {
				formattedAttributes[trimmedAttr].push(trimmedValue);
			} else {
				formattedAttributes[trimmedAttr] = [trimmedValue];
			}
		});

		const formatteddata = {
			domain_id: selectedDomain.domain_id,
			domain_name: selectedDomain.domain,
			categories: [
				{
					cat_id: selectedCategory.cat_id,
					cat_name: selectedCategory.cat_name,
					attributes: formattedAttributes,
				},
			],
		};

		setLoading(true);
		trackPromise(
			taxonomyService.createAttributes({ id: selectedDomain.domain_id, cat_id: selectedCategory.cat_id, attributes: formattedAttributes })
				.then((response) => {
					// alert(response.data.message);
					if (response.status === 200) {
						getAllDomains();
						toast({
							title: `${response.data.message}`,
							position: "top",
							status: "success",
							duration: 2000,
							variant: "left-accent",
							isClosable: true,
						})
					}
				})
				.catch((err) => {
					console.log("create attribute err: ", err)
				})
				.finally(() => {
					setLoading(false)
				})
		);
	};

	const handleDeleteDomain = async (domain) => {
		const confirmDelete = await confirm({
			title: `Delete the ${domain.domain} domain?`,
			message: `Deleting the ${domain.domain} domain will delete all its associated categories and attributes.`,
			confirmLabel: "Delete",
		});
		if (confirmDelete) {
			setLoading(true);
			taxonomyService.deleteDomain({ id: `${domain.domain_id}`, status: 0 })
				.then((response) => {
					// getAllDomains();
					const data = response.data.taxnonmies;
					const processedData = processData(data);
					setDomainsData(processedData);
				})
				.catch((err) => {
					console.log("delete domain err:", err)
				})
				.finally(() => {
					setLoading(false)
				})
		} else {
			// User cancelled the deletion, do nothing
		}
	};

	const handleDeleteCategory = async (domain, category) => {
		const confirmDelete = await confirm({
			title: `Delete the ${category.cat_name} category?`,
			message: `Deleting the ${category.cat_name} category will delete all the associated attributes.`,
			confirmLabel: "Delete",
		});
		if (confirmDelete) {
			setLoading(true);
			trackPromise(
				taxonomyService
					.deleteCategory({ id: domain.domain_id, cat_id: category.cat_id })
					.then((response) => {
						// alert(response.data.message);
						if (response.status === 200) {
							toast({
								title: `${response.data.message}`,
								position: "top",
								status: "success",
								duration: 2000,
								variant: "left-accent",
								isClosable: true,
							})
						}
						getAllDomains();
						setLoading(false);
					})
					.catch((err) => {
						setLoading(false);
					})
			);
		}
	};

	const handleSelectionChange = (selectedOptions) => {
		setSelectedIds(selectedOptions);
	};

	const departmentOptions = activeDepartments?.map((department) => ({
		label: `${department?.department_name} (${department?.department_code})`,
		value: department?.id,
	}));

	const department_id = selectedIds.map((option) => option.value);
	const handleExcelClick = async (domain) => {
		const payload = {
			comp_id: comp_id,
			domain_id: domain.id
		}
		setSelectedDomainData(domain);
		setDomainNameModal(domain.domain)
		setExcelSelectedData(domain.download_column || {});
		// setDomainId(domain.id)
		setIsExcel(true);
		setLoading(true)
		try {
			const response = await taxonomyService.getAttribute(payload)
			setExcelData(response)
		} catch (err) {
			console.log(err)
		} finally {
			setLoading(false)
		}

	};
	const handleDownloadColumnChange = (index, value, mode) => {
		const updatedRows = [...excelrows];
		if (mode == 'Input') {
			updatedRows[index].input = value;
		}
		else {
			updatedRows[index].select = value;
		}
		setExcelRows(updatedRows);
	};
	const addExcelRow = () => {
		setExcelRows([...excelrows, { input: "", select: "" }]);
	};

	const removeExcelRow = async (index) => {
		const row = excelrows[index];
		// A row that was just added and is still blank needs no "are you sure".
		if (row && (row.input || row.select)) {
			const confirmed = await confirm({
				title: "Remove this column?",
				message: `${row.input ? `The "${row.input}" download column` : "This download column"} will be removed.\nThe change is only saved when you click Submit.`,
				confirmLabel: "Remove",
			});
			if (!confirmed) return;
		}
		const updatedRows = excelrows.filter((_, i) => i !== index);
		setExcelRows(updatedRows);

		// Remove the key from excelSelcetedData
		const newExcelData = { ...excelSelcetedData };
		delete newExcelData[excelrows[index].input];
		setExcelSelectedData(newExcelData);
	};
	const handleExcelSubmit = async () => {
		const isEmpty = excelrows.some(row => row.input.trim() === "");
		if (isEmpty) {
			toast({
				title: "Validation Error",
				description: "All fields must be filled before submitting.",
				status: "error",
				duration: 3000,
				position: "top",
				isClosable: true,
			});
			return;
		}

		setLoading(true);
		// getAllDomains()
		const download_column = excelrows.reduce((acc, row) => {
			acc[row.input] = row.select;
			return acc;
		}, {})

		const updateDomain = {
			...selectedDomainData,
			// id: (domainId),
			id: selectedDomainData.id,
			download_column: download_column
		}

		try {
			const response = await taxonomyService.updateDomain(updateDomain)
			if (response.status === 200) {

				setDomainsData((prevState) => ({
					...prevState,
					domains: prevState.domains.map((domain) =>
						domain.domain_id === updateDomain.domain_id
							? updateDomain
							: domain
					),
				}));
				setIsExcel(false);
				toast({
					title: `${response.data.new.message}`,
					position: "top",
					status: "success",
					duration: 2000,
					variant: "left-accent",
					isClosable: true,
				})
				setSelectedDomain(updateDomain); // Keep the updated domain as selected
				// const data = response.data.taxnonmies;
				// const processedData = processData(data);
				// setDomainsData(processedData);
			}
		} catch (err) {
			console.log(err)
		} finally {
			setLoading(false)
		}


	};

	return (
		<>
			<Flex
				padding={"0px 0px 3px 0px"}
				alignItems={"center"}
				justifyContent={"space-between"}
				borderBottom={"0.5px solid #BDBDBD"}
				mt={{ base: "8px", md: "12px", lg: "auto" }}
				mb={{ base: "10px", md: "17px", lg: "25px" }}
			>
				<Flex gap={"12px"} alignItems={"center"}>
					<h2>Taxonomy</h2>
				</Flex>
				<NavLink to="/layout" className="crossBtn">
					<span><RxCross1 /></span>
				</NavLink>
			</Flex>
			<div className="sidebar">
				{loading && <LoadingOverlay message={loaderMessage} />}
				<div className={`section domain ${domainOpen ? "" : "closed"}`}>
					<Flex justifyContent={"space-between"}>
						<h5>Domain</h5>
						<Button
							width="27px"
							height="27px"
							borderRadius="25px"
							bgGradient="linear(to-r, #F90A8B, #F90A8B)"
							color="#FFFFFF"
							_hover={{
								color: "#FFFFFF",
							}}
							fontSize="17px"
							onClick={() => handleShow()}
						>
							<Flex alignItems={"center"} justifyContent={"center"}>
								<FiPlus />
							</Flex>
						</Button>
					</Flex>
					<div className="separator"></div>

					<table className="table">
						<thead>
							<tr
								className="domain-con-default"
								style={{ borderBottom: "1px solid #DEE2E6" }}
							>
								<th
									style={{
										background: "#FFFFFF",
										fontWeight: "bold",
										fontSize: "14px",
										color: "black",
										width: "160px",
									}}
								>
									Domain
								</th>
								<th
									style={{
										background: "#FFFFFF",
										fontWeight: "bold",
										fontSize: "14px",
										color: "black",
										//   width: "160px",
										float: "right",
										borderBottom: "none",
									}}
								>
									Action
								</th>
							</tr>
						</thead>
						<tbody>
							{domainsData.domains.map((domain) => (
								<tr
									key={domain.domain_id}
									onClick={() => handleDomainClick(domain)}
									className={
										selectedDomain &&
											selectedDomain.domain_id === domain.domain_id
											? "selected"
											: "domain-con-default"
									}
									style={{ borderBottom: "1px solid #DEE2E6" }}
								>
									<td style={{ fontSize: "12px" }} className={selectedDomain?.domain_id === domain?.domain_id ? "selectedDomainAttr" : ""}>{domain.domain}</td>
									<td style={{ display: "flex", float: "right", gap: "7px", borderBottom: "none" }}>
										<FaFileExcel onClick={() => handleExcelClick(domain)} />
										<BiPencil onClick={() => handleShow(domain)} />
										<BiTrash
											color={
												selectedDomain &&
													selectedDomain.domain_id === domain.domain_id
													? `red`
													: "#ff6363"
											}
											style={{ cursor: "pointer" }}
											title="delete domain"
											onClick={() => handleDeleteDomain(domain)}
										></BiTrash>
									</td>
								</tr>
							))}
						</tbody>
					</table>
				</div>

				<div className={`section category ${categoryOpen ? "" : "closed"}`}>
					<Flex justifyContent={"space-between"}>
						<h5>Category</h5>
						<Button
							width="27px"
							height="27px"
							borderRadius="25px"
							bgGradient="linear(to-r, #F90A8B, #F90A8B)"
							color="#FFFFFF"
							_hover={{
								color: "#FFFFFF",
							}}
							fontSize="17px"
							onClick={() => handleShowCategoryModal("add")}
						>
							<Flex alignItems={"center"} justifyContent={"center"}>
								<FiPlus />
							</Flex>
						</Button>
					</Flex>
					<div className="separator"></div>

					<table className="table">
						<thead>
							<tr
								className="domain-con-default"
								style={{ borderBottom: "1px solid #DEE2E6" }}
							>
								<th
									style={{
										background: "#FFFFFF",
										fontWeight: "bold",
										fontSize: "14px",
										color: "black",
										width: "160px",
									}}
								>
									Category
								</th>
								<th
									style={{
										background: "#FFFFFF",
										fontWeight: "bold",
										fontSize: "14px",
										color: "black",
										//   width: "160px",
										float: "right",
										borderBottom: "none",
									}}
								>
									Action
								</th>
							</tr>
						</thead>
						<tbody>
							{defaultselectedCategories.map((category) => (
								<tr
									key={category.cat_id}
									onClick={() => handleCategoryClick(category)}
									className={
										selectedCategory &&
											selectedCategory.cat_id === category.cat_id
											? "selected"
											: "domain-con-default"
									}
									style={{ cursor: "pointer", borderBottom: "1px solid #DEE2E6" }}
								>
									<td style={{ fontSize: "12px" }} className={selectedCategory?.cat_id === category?.cat_id ? "selectedDomainAttr" : ""}>{category.cat_name}</td>
									<td style={{ display: "flex", float: "right", gap: "7px", borderBottom: "none" }}>
										<BiPencil onClick={() => handleEditCategory(category)} />

										<BiTrash
											color={
												selectedCategory &&
													selectedCategory.cat_id === category.cat_id
													? `red`
													: "#ff6363"
											}
											style={{ cursor: "pointer" }}
											title="delete category"
											onClick={() =>
												handleDeleteCategory(selectedDomain, category)
											}
										/>
									</td>
								</tr>
							))}
						</tbody>
					</table>
				</div>

				<div className="Attrsection attributes">
					<div className="attrHead">
						<h5>Attributes</h5>
						<div className="Attrseparator"></div>
					</div>

					<div className="fixed-header">
						<table className="table table-bordered">
							<thead>
								<tr>
									<th style={{ background: "#FFFFFF", fontWeight: "bold", fontSize: "14px", color: "black", width: "25%" }}>Attribute</th>
									<th style={{ background: "#FFFFFF", fontWeight: "bold", fontSize: "14px", color: "black", width: "60%" }}>Description</th>
									<th style={{ background: "#FFFFFF", fontWeight: "bold", fontSize: "14px", color: "black", width: "15%" }}>Action</th>
								</tr>
							</thead>
						</table>
					</div>

					<div className="attributes-content">
						<table className="table table-bordered">
							<tbody>
								{attributes.map((attribute, index) => (
									<tr key={index}>
										<td style={{ fontSize: "12px", width: "25%" }}>
											<input type="text" className="form-control" value={attribute.attribute} onChange={(e) => handleInputChange(index, "attribute", e.target.value)} />
										</td>
										<td style={{ fontSize: "12px", width: "60%" }}>
											<input type="text" className="form-control" value={attribute.value} onChange={(e) => handleInputChange(index, "value", e.target.value)} />
										</td>
										<td style={{ color: "red", width: "15%" }}>
											<BiTrash style={{ fontSize: "18px", cursor: "pointer" }} onClick={() => handleRemoveAttribute(index)} title="remove row" />
										</td>
									</tr>
								))}
							</tbody>
						</table>

						{selectedCategory && selectedCategory.cat_id && (
							<>
								<Button width="27px" height="27px" borderRadius="25px" bgGradient="linear(to-r, #F90A8B, #F90A8B)" color="#FFFFFF" _hover={{ color: "#FFFFFF" }} fontSize="17px" onClick={handleAddAttribute}>
									<Flex alignItems={"center"} justifyContent={"center"}>
										<FiPlus />
									</Flex>
								</Button>

								<div className="submit-btn" style={{ textAlign: "center" }}>
									<Button variant={"outline"} id="btn" size={"md"} disabled={loading} onClick={handleSaveAttributes}> Submit </Button>
								</div>
							</>
						)}
					</div>
				</div>

				{/* enforceFocus off: the "Remove this column?" confirm dialog opens on top of this modal and must be able to take focus. */}
				<Modal show={isExcel} onHide={() => setIsExcel(false)} centered size="lg" enforceFocus={false}>
					<Modal.Header closeButton>
						<Modal.Title>Domain Name :{domainNameModal}</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<div className="fixed-header">
							<table className="table table-bordered">
								<thead>
									<tr>
										<th style={{ width: "25%" }}>Column Name</th>
										<th style={{ width: "60%" }}>Mapped Tag name</th>
										<th style={{ width: "15%" }}>Action</th>
									</tr>
								</thead>
							</table>
						</div>
						<div className="attributes-content">
							<table className="table table-bordered">
								<tbody>
									{excelrows.map((row, index) => (
										<tr key={index}>
											{/* Input Field */}
											<td style={{ fontSize: "12px", width: "25%" }}>
												<input
													type="text"
													className="form-control"
													value={row.input}
													onChange={(e) => handleDownloadColumnChange(index, e.target.value, "Input")}
												/>
											</td>
											<td style={{ fontSize: "12px", width: "60%" }}>
												<select
													className="form-control"
													value={row.select}
													onChange={(e) => handleDownloadColumnChange(index, e.target.value, "Select")}
												>
													<option value="" >(Blank)</option>
													{Object.entries(excelData)
														.sort(([keyA], [keyB]) => (keyA === "General" ? -1 : keyB === "General" ? 1 : 0))
														.map(([group, options]) => (
															<optgroup key={group} label={group}>
																{options.map((option, subIndex) => (
																	<option key={subIndex} value={`${group}$${option}`}>{option}</option>
																))}
															</optgroup>
														))}
												</select>
											</td>
											<td style={{ color: "red", width: "15%" }}>
												<BiTrash
													style={{ fontSize: "18px", cursor: "pointer" }}
													onClick={() => removeExcelRow(index)}
													title="Remove Row"
												/>
											</td>
										</tr>
									))}
								</tbody>
							</table>
						</div>
					</Modal.Body>
					<Modal.Footer>
						<div style={{ display: "flex", justifyContent: "flex-start", width: "100%" }}>
							<Button width="27px" height="27px" borderRadius="25px" bgGradient="linear(to-r, #F90A8B, #F90A8B)" color="#FFFFFF" _hover={{ color: "#FFFFFF" }} fontSize="17px" onClick={addExcelRow}>
								<Flex alignItems={"center"} justifyContent={"center"}>
									<FiPlus />
								</Flex>
							</Button>
						</div>
						<div className="submit-btn" style={{ textAlign: "center" }}>
							<Button variant={"outline"} id="btn" size={"md"} disabled={loading} onClick={handleExcelSubmit}> Submit </Button>
							<Button variant="secondary" onClick={() => setIsExcel(false)}>
								Cancel
							</Button>
						</div>
					</Modal.Footer>
				</Modal>


				<Modal show={show} onHide={handleClose} animation={false} size="lg">
					<Modal.Header closeButton>
						<Modal.Title className="modal-header-text">
							{mode === "edit" ? "Edit Domain" : "Add Domain"}
						</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<Box display={"flex"} flexDir={"column"} gap={"12px"}>
							<Flex flexDir={"column"} alignItems={"flex-start"} justifyContent={"flex-start"}>
								<FormLabel>Domain Name {mode !== 'edit' && <span style={{ color: "red" }}>*</span>}</FormLabel>
								<input
									type="text"
									className="inp_field"
									placeholder="Domain Name"
									value={domainNameModal} // Use domainNameModal here
									onChange={(e) => setDomainNameModal(e.target.value)} // Update domainNameModal
								/>
							</Flex>
							<Flex
								flexDir={"column"}
								alignItems={"flex-start"}
								justifyContent={"flex-start"}
							>
								<FormLabel>
									Department {mode !== 'edit' && <span style={{ color: "red" }}>*</span>}
								</FormLabel>
								<MultiSelect
									options={departmentOptions}
									value={selectedIds}
									onChange={handleSelectionChange}
									labelledBy="Select Departments"
									className={MultiSelectStyle.multi_selecet_input}
								/>
							</Flex>
							<Flex
								flexDir={"column"}
								alignItems={"flex-start"}
								justifyContent={"flex-start"}
							>
								<FormLabel>
									Domain Description {mode !== 'edit' && <span style={{ color: "red" }}>*</span>}
								</FormLabel>
								<input
									type="text"
									className="inp_field"
									value={domainDesc} // Use domainNameModal here
									onChange={(e) => setDomainDesc(e.target.value)} // Update domainNameModal
								/>
							</Flex>
							{(role === "superAdmin" || role === "Admin") && (
								<Flex
									flexDir={"column"}
									alignItems={"flex-start"}
									justifyContent={"flex-start"}
								>
									<FormLabel>
										Description Prompts {mode !== 'edit' && <span style={{ color: "red" }}>*</span>}
									</FormLabel>
									<MultiSelect
										options={prompt}
										value={selectedprompt}
										onChange={setSelectedPrompt}
										labelledBy="Select"
										hasSelectAll={true}
										className={MultiSelectStyle.multi_selecet_input}

									/>
								</Flex>
							)}

							{role === 'superAdmin' && <Flex
								flexDir={"column"}
								alignItems={"flex-start"}
								justifyContent={"flex-start"}
							>
								<FormLabel>Custom Prompt</FormLabel>
								<PromptEditor domainPrompt={domainPrompt} setDomainPrompt={setDomainPrompt} />
							</Flex>
							}
						</Box>
					</Modal.Body>
					<Modal.Footer>
						<Flex w={"100%"}
							alignItems={"center"}
							justifyContent={"center"}
							gap={"10px"}
						>
							<Button disabled={loading} id="btn" size={"sm"} onClick={handleSaveDomain}>
								{mode === "edit" ? `${!loading ? "Save" : "Loading..."}` : `${!loading ? 'Submit' : "Loading..."}`}
							</Button>
							<Button
								colorScheme={"red"}
								variant={"outline"}
								size={"sm"}
								onClick={handleClose}
							>
								Close
							</Button>
						</Flex>
					</Modal.Footer>
				</Modal>
				<Modal
					show={showCategoryModal}
					onHide={handleCloseCategoryModal}
					animation={false}
				>
					<Modal.Header closeButton>
						<Modal.Title className="modal-header-text">
							{mode === "edit" ? "Edit Category" : "Add Category"}
						</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<Box>
							<Flex
								flexDir={"column"}
								alignItems={"flex-start"}
								justifyContent={"flex-start"}
							>
								<FormLabel>
									Category Name {mode !== 'edit' && <span style={{ color: "red" }}>*</span>}
								</FormLabel>
								<input
									className="inp_field"
									type="text"
									name="category"
									value={editCategoryName} // Use the new state for input value
									onChange={(e) => setEditCategoryName(e.target.value)} // Update the new state
								/>
							</Flex>
						</Box>
					</Modal.Body>
					<Modal.Footer>
						<Flex
							width={"100%"}
							alignItems={"center"}
							justifyContent={"center"}
							gap={"10px"}
						>
							<Button
								id="btn"
								size={"sm"}
								disabled={loading}
								onClick={handleAddCategory}
							>
								{mode === "edit" ? "Save" : "Add"}
							</Button>
							<Button
								variant={"outline"}
								size={"sm"}
								onClick={handleCloseCategoryModal}
								colorScheme={"red"}
							>
								Close
							</Button>
						</Flex>
					</Modal.Footer>
				</Modal>
			</div>
		</>
	);
});

export default Taxonomy;
